import { h } from 'preact';
// eslint-disable-next-line react/no-deprecated, import/no-unresolved
import { render } from 'react';
import Carousel from '../../auto/carousel';
import WhatsappChatConversionForm from '../../auto/components/Whatsapp/ChatConversionForm';
import WhatsAppFormModal from '../../auto/components/WhatsAppFormModal';

(() => {
  window.h = h;
  window.render = render;
  /**
   * Para ser usado quando se deseja sobrescrever conteúdo do container de rendeziração.
   * Seu uso é semelhante a função render
   */
  window.hydrate = (vnode, parent) =>
    render(vnode, parent, parent.firstElementChild);

  const components = {
    Carousel,
    WhatsAppFormModal,
    WhatsappChatConversionForm,
  };

  Object.keys(components).forEach(c => {
    window[c] = components[c];
  });
})();
